module.exports = __webpack_public_path__ + "img/vote-btn_txt_pre.f1df25d3.png";